import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TaskIdentityInterface } from '@vendasta/task';
import { AskQuestionInfo, ProductInfo, Subtask } from '../shared/interfaces';
import { MILESTONE_COMPLETED } from '../shared/constants';

interface ProjectProgress {
  completed: number;
  total: number;
  progress: number;
}

@Component({
  selector: 'project-tracker-fulfillment-tracker',
  templateUrl: './fulfillment-tracker.component.html',
  styleUrls: ['./fulfillment-tracker.component.scss'],
  standalone: false,
})
export class FulfillmentTrackerComponent implements OnInit {
  @Input() product: ProductInfo;
  @Input() projectTitle;
  @Input() projectIdentity: TaskIdentityInterface;
  @Input() subtasks: Subtask[] = [];
  @Input() hideAskQuestion = false;
  @Input() expanded = false;
  @Output() askQuestionClicked: EventEmitter<AskQuestionInfo> = new EventEmitter<AskQuestionInfo>();
  projectProgress: ProjectProgress;

  ngOnInit(): void {
    const completed: number = this.subtasks?.filter((subtask) => subtask.status === MILESTONE_COMPLETED)?.length || 0;
    const total: number = this.subtasks?.length || 0;
    const progress: number = total > 0 ? Math.round((completed / total) * 100) : 0;
    this.projectProgress = { completed, total, progress };
  }

  handleAskQuestionClicked(event?: MouseEvent): void {
    this.askQuestionClicked.emit({
      projectIdentity: this.projectIdentity,
      subtasks: this.subtasks,
    });
    event?.preventDefault();
    event?.stopPropagation();
  }
}
